import { ENUM__workspace_entity_collection } from './ENUM__workspace_entity_collection';

export const ENUM__workspace_entity = {
  ...ENUM__workspace_entity_collection, // Spreading the collections in

  ENTITY_SEARCH: 'search',
  ENTITY_GENERATION: 'generation',
  ENTITY_USER_TASK: 'user_task',
} as const;

// Create types from the objects
export type ENUM__workspace_entity = (typeof ENUM__workspace_entity)[keyof typeof ENUM__workspace_entity];
